module.exports = __webpack_public_path__ + "img/logo_golf_w@2x.89d8f5b0.png";